import axios from "../../../util/axios";
import { AxiosResponse } from "axios";
import projectConfig from "../../../projectConfig.json";
import { NavGridEditability } from "../../../context/RegistryContexts/RegistryUserContext";

const { hostCloud } = projectConfig.api;

const url = `${hostCloud}/legacy/request`;

interface RegistryResponse {
   default: {
      [key: string]: NavGridEditability | null;
   };
}

interface UserRegistryParameters {
   regKey: string;
   defaultValue: string;
}

export const getRegistry = async (regKey: string): Promise<AxiosResponse<RegistryResponse>> => {
   return axios({
      method: "post",
      url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/registry`,
         httpMethod: "GET",
         isAuthenticated: true,
         parameters: `/{"regKey":"${regKey}"}`,
      },
   });
};

export const getUserRegistry = async (
   regKey: string,
   defaultValue: string,
): Promise<AxiosResponse<RegistryResponse>> => {
   const parameters: UserRegistryParameters = {
      regKey,
      defaultValue: defaultValue ?? "1",
   };

   return axios({
      method: "post",
      url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/registry-user`,
         httpMethod: "GET",
         isAuthenticated: true,
         parameters: JSON.stringify(parameters),
      },
   });
};

export const setUserRegistry = async (
   regKey: string,
   regValue: NavGridEditability,
   description?: string,
   groupname?: string,
   unit?: string,
): Promise<AxiosResponse<RegistryResponse>> => {
   const body = {
      regKey,
      regValue,
      description,
      groupname,
      unit,
   };

   return axios({
      method: "post",
      url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/registry-user/method/store`,
         httpMethod: "POST",
         isAuthenticated: true,
         body: JSON.stringify(body),
      },
   });
};
